export default function CtaSection() {
  return (
    <section className="w-full relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20fashion%20retail%20display%20with%20carefully%20arranged%20shoes%20bags%20and%20accessories%20on%20minimalist%20shelves%2C%20warm%20ambient%20lighting%2C%20cream%20and%20beige%20tones%2C%20sophisticated%20boutique%20aesthetic%2C%20soft%20bokeh%20background%2C%20editorial%20style%20product%20photography&width=1600&height=600&seq=cta-bg-v2&orientation=landscape&nocache=true"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/85 to-primary-700/75"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Ready to Start Shopping?
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 max-w-lg mx-auto leading-relaxed">
          Visit our main website to explore thousands of curated products, complete spreadsheets, and connect with the Basetao shopping community.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Basetao Spreadsheet
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-cart-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}